import React from 'react';
import { Col, Row, Button } from 'react-bootstrap';
import { Formik, Form } from 'formik';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
	getAdminNotificatiosAction,
	getUserNotificationSettingsAction,
	updateSettingsAction,
} from './../../actions/NotificationActions';

class NotificationSetting extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			userNotificationListingData: [],
			systemNotificationListingData: [],
			userNotifications: [],
			groupedNotification: [],
			showLoader:true,
		};
	}

	componentDidMount() {
		this.setState({showLoader : true});
		this.getNotiSettings()
	}

	/**
	 * @desc Get Notification types to list
	 */
	getNotiSettings() {
		this.props.getAdminNotificatiosAction().then(response => {
			this.setState({ userNotificationListingData: response.data }, () =>
				this.props.getUserNotificationSettingsAction().then(userlisting => {
					this.setState({ systemNotificationListingData: userlisting.data }, () =>
						this.getNewMsgNotifications()
					);
				}).catch(err => {})
			);
		}).catch(err => {});
	}

	/**
	 * @desc matching data for user notification list for display
	 */
	getNewMsgNotifications() {
		this.state.userNotificationListingData &&
			this.state.userNotificationListingData.map(res => {
				return (
					this.state.systemNotificationListingData &&
					this.state.systemNotificationListingData.map(res1 => {
						if (res._id == res1.systemNotificationId && res.isVisibleToUser) {
							res1['description'] = res.description;
							res1['type'] = res.type;
						}
					})
				);
			});

			this.setState({showLoader : false});
	}

	/**
	 * @desc Call api for update settings data
	 * @param {*} data 
	 */
	updateSettings(data) {
		this.setState({showLoader : true});
		this.props.updateSettingsAction(data.radioObject).then(res => {
			this.getNotiSettings();
		}).catch(err => {});
	}

	cancel = () => {
		this.props.history.goBack();
	};

	render() {

		if(this.state.showLoader ) {
			return(
			  <div className="page-loader fixed">
				<div className="page-loader-inner">
				  <div className="spinner-border" role="status">
					<span className="sr-only">Loading...</span>
				  </div>
				</div>
			  </div>
			) 
		  }
		  else {

			return (
				<>
					<Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center">
						<Col className="col-auto">
							<h4 className="title-med mt-0 pt-1">Notification Settings</h4>
						</Col>
					</Row>
					<div className="admin-content-area single">
						<Formik
							enableReinitialize={true}
							initialValues={{ radioObject: this.state.systemNotificationListingData }}
							onSubmit={values => {
								this.updateSettings(values);
							}}
						>
							{({								
								values,
								submitForm,
								setFieldValue
							}) => (
								<Form>
									<div className="notification-setting">
										{values.radioObject &&
											values.radioObject.map((obj, i) => {
												if(obj.description){
												return (
													<Row className="form-group align-items-center" key={i}>
														<Col className="col-auto">
															<h4>{obj.description && obj.description}</h4>
														</Col>

														<Col className="pl-0">
															<div className="custom-control custom-control-inline custom-radio">
																<input
																	type="radio"
																	className="custom-control-input"
																	name={'radioObject[' + i + '].enable'}
																	key={'radioObject[' + i + ']' + 1}
																	checked={values.radioObject[i].enable}
																	id={'displayMessageEnable' + i}
																	onChange={value => {
																		setFieldValue(
																			'radioObject[' + i + '].enable',
																			!obj.enable
																		);
																		let systemNotificationListingData = this.state
																			.systemNotificationListingData;
																		systemNotificationListingData[
																			i
																		].enable = !systemNotificationListingData[i].enable;
																	}}
																	value={true}
																/>
																<label
																	title=""
																	for={'displayMessageEnable' + i}
																	className="custom-control-label"
																>
																	Enable
																</label>
															</div>
															<div className="custom-control custom-control-inline custom-radio">
																<input
																	type="radio"
																	className="custom-control-input"
																	value={false}
																	id={'displayMessageDisable' + i}
																	key={'radioObject[' + i + ']' + 2}
																	name={'radioObject[' + i + '].enable'}
																	checked={!values.radioObject[i].enable}
																	onChange={value => {
																		setFieldValue(
																			'radioObject[' + i + '].enable',
																			!obj.enable
																		);
																		let systemNotificationListingData = this.state
																			.systemNotificationListingData;
																		systemNotificationListingData[
																			i
																		].enable = !systemNotificationListingData[i].enable;
																	}}
																/>

																<label
																	title=""
																	for={'displayMessageDisable' + i}
																	className="custom-control-label"
																>
																	Disable
																</label>
															</div>
														</Col>
													</Row>
												);}
											})}

										<Row className="form-group pt-4">
											<Col>
												<Button
													type="submit"
													variant="primary"
													className="btn-blue w-90 font-14 mr-3"
												>
													Save
												</Button>
												<Button
													variant="primary"
													className="btn-blue btn-outlined w-90 font-14"
													onClick={this.cancel}
												>
													Cancel
												</Button>
											</Col>
										</Row>
									</div>
								</Form>
							)}
						</Formik>
					</div>
				</>
			);
		}
	}
}


const mapStateToProps = state => {
	return {		
	};
};
NotificationSetting.propTypes = {
	history: PropTypes.object,
};

export default connect(mapStateToProps, {
	getAdminNotificatiosAction,
	getUserNotificationSettingsAction,
	updateSettingsAction,
})(NotificationSetting);
